/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeExecutionFollowUpScheduleAnchor } from './EmployeeExecutionFollowUpScheduleAnchor';
import type { EmployeeExecutionSchedule } from './EmployeeExecutionSchedule';
/**
 * Employee follow-up replacement operation executed by the native runtime.
 */
export type EmployeeExecutionFollowUpReplaceOperation = {
    /**
     * Stable operation discriminator.
     */
    kind: EmployeeExecutionFollowUpReplaceOperation.kind;
    /**
     * Self-contained follow-up condition and action.
     */
    description: string;
    /**
     * Conversation event from which a relative delay starts.
     */
    scheduleAnchor: EmployeeExecutionFollowUpScheduleAnchor;
    /**
     * Structured schedule resolved from the follow-up protocol.
     */
    schedule: EmployeeExecutionSchedule;
};
export namespace EmployeeExecutionFollowUpReplaceOperation {
    /**
     * Stable operation discriminator.
     */
    export enum kind {
        FOLLOW_UP_REPLACE = 'follow-up-replace',
    }
}

